module.exports = __webpack_public_path__ + "img/nivel-ouro.0390a836.svg";